// src/components/data-sources/connectorIconFiles.ts
//
// Brand marks a connector ships as a file instead of as a case in
// ConnectorIcon / DataSourceIcon (plan 2026-10-13-connector-catalog-on-request,
// step 0.6). Connectors are built in parallel lanes that may only touch
// vendor-named paths; a mark at `icons/connectors/<connector module>.svg`
// (e.g. `sendcloud.svg` for SENDCLOUD) is picked up here with no edit to a
// shared file. The wave-setup commit drops a neutral placeholder there; the
// lane replaces it with the real mark.
//
// The connectors that predate this keep their explicit imports and cases.

import type { FC, SVGProps } from "react";

type SvgComponent = FC<SVGProps<SVGSVGElement>>;

const FILES = import.meta.glob<SvgComponent>("./icons/connectors/*.svg", {
  eager: true,
  query: "?react",
  import: "default",
});

/** CONNECTOR_TYPE → mark, keyed by the file name upper-cased. */
export const CONNECTOR_ICON_FILES: Readonly<Record<string, SvgComponent>> = Object.fromEntries(
  Object.entries(FILES).map(([path, component]) => [
    path.replace(/^.*\//, "").replace(/\.svg$/, "").toUpperCase(),
    component,
  ]),
);
